import type { SVGProps } from "react";

export const InfoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_876_7239)">
      <path
        d="M8.2487 10.6666V7.99992M8.2487 5.33325H8.25536M14.9154 7.99992C14.9154 11.6818 11.9306 14.6666 8.2487 14.6666C4.5668 14.6666 1.58203 11.6818 1.58203 7.99992C1.58203 4.31802 4.5668 1.33325 8.2487 1.33325C11.9306 1.33325 14.9154 4.31802 14.9154 7.99992Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_876_7239">
        <rect width="16" height="16" fill="white" transform="translate(0.25)" />
      </clipPath>
    </defs>
  </svg>
);
